module.exports = __webpack_public_path__ + "img/tag_extra.cbaec0fc.svg";